'use strict';

var RecapDtdDowPaxGapAggregationFactory = function RecapDtdDowPaxGapAggregationFactory(DataAggregationFactory) {
  function RecapDtdDowPaxGapAggregation() {
    DataAggregationFactory.call(this, 'rom-analysis-flattened-services-mode', 'recap-dtd-dow-pax-gap');
  }
  RecapDtdDowPaxGapAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  RecapDtdDowPaxGapAggregation.constructor = RecapDtdDowPaxGapAggregation;
  RecapDtdDowPaxGapAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  RecapDtdDowPaxGapAggregation.prototype.aggregate = function (data, metricsKeys) {
    var aggregatedRecapPaxGap = [],
      map = [];
    var self = this;
    for (var i = 0; i < data.length; i++) {
      var record = data[i];
      var daysToDeparture = record.daysToDeparture;
      var mapDtdRangeIndex = map.indexOf(daysToDeparture);
      var dow = record.dow;
      var recapPaxGap = {};
      if (mapDtdRangeIndex === -1) {
        recapPaxGap[dow] = self.getMetricValue(record.recapPaxGap, metricsKeys, true);
        recapPaxGap.daysToDeparture = daysToDeparture;
        aggregatedRecapPaxGap.push(recapPaxGap);
        map.push(daysToDeparture);
      } else if (!aggregatedRecapPaxGap[mapDtdRangeIndex][dow]) {
        aggregatedRecapPaxGap[mapDtdRangeIndex][dow] = self.getMetricValue(record.recapPaxGap, metricsKeys, true);
      } else {
        aggregatedRecapPaxGap[mapDtdRangeIndex][dow] += self.getMetricValue(record.recapPaxGap, metricsKeys, true);
      }
    }
    return aggregatedRecapPaxGap;
  };
  return RecapDtdDowPaxGapAggregation;
};
RecapDtdDowPaxGapAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory'];
module.exports = RecapDtdDowPaxGapAggregationFactory;